import AdminNewsForm from './AdminNewsForm';
import React, {useEffect} from 'react';
import {FormikProps, useFormik} from 'formik';
import {AdminNewsFormValues, NewsSchema} from '../Types/news';
import {useIntl} from 'react-intl';
import FormModal from '../../../Components/FormModal';
import {useCreateNews} from '../Hooks/NewsHooks';

interface AddNewsModalProps {
  show: boolean;
  hide: () => void;
}

const AddNewsModal = ({show, hide}: AddNewsModalProps): JSX.Element => {
  const intl = useIntl();

  const {mutate} = useCreateNews();

  const formik: FormikProps<AdminNewsFormValues> = useFormik({
    initialValues: {
      category_id: 1,
      start_date: '',
      end_date: '',
      moreType: 'none',
      news: '',
      title: '',
      description: '',
      type: 'encart',
      frequency: 'session',
    },
    validationSchema: NewsSchema(intl),
    validateOnChange: true,
    onSubmit: async (values: AdminNewsFormValues, {resetForm}) => {
      mutate(values, {
        onSuccess: () => {
          resetForm();
          hide();
        },
      });
    },
  });

  useEffect(() => {
    if (show) {
      formik.resetForm();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  return (
    <FormModal
      title={'Nouvelle news'}
      show={show}
      onHide={hide}
      size="lg"
      disable={formik.isSubmitting || !formik.isValid}
      onSubmit={() => formik.submitForm()}
    >
      <AdminNewsForm formik={formik} />
    </FormModal>
  );
};

export default AddNewsModal;
